// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.progress {\r\n    background-color: #f3f3f3;\r\n    border-radius: 5px;\r\n    overflow: hidden;\n}\n.progress-bar {\r\n    height: 100%;\r\n    transition: width 0.4s ease;\n}\r\n", ""]);
// Exports
module.exports = exports;
